import Button from '../../../../../components/Button/Button';
import DialogModal from '../../../../../components/DialogModal/DialogModal';
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage';
import MaxWidth from '../../../../../components/MaxWidth/MaxWidth';
import Paragraph from '../../../../../components/Paragraph/Paragraph';
import Row from '../../../../../components/Row/Row';
import SVG from '../../../../../components/SVG/SVG';
import Stack from '../../../../../components/Stack/Stack';
import Title from '../../../../../components/Title/Title';
import useTrans from '../../../../../hooks/ui/useTrans';
import ErrorList from '../../../../../types/UI/ErrorList';

import icon from './graphics/icon.svg?raw';

import styles from './CustomerBookingConditionDialog.module.css';

type CustomerBookingConditionDialogProps = {
    error: ErrorList;
    onBack: () => void;
};

const CustomerBookingConditionDialog = ({
    error,
    onBack,
}: CustomerBookingConditionDialogProps) => {
    const trans = useTrans(
        'CustomerArea.BookingForm.CustomerBookingConditionDialog.'
    );

    return (
        <DialogModal onCloseRequested={onBack} width="small" isOpen>
            <Stack space="large">
                <Row horizontal="center">
                    <MaxWidth width={80}>
                        <SVG src={icon} className={styles.Icon} />
                    </MaxWidth>
                </Row>

                <Title variant="area" align="center">
                    {trans('Title')}
                </Title>

                <Paragraph align="center" bold>
                    {trans('Intro')}
                </Paragraph>

                <ErrorMessage level="warning">{error}</ErrorMessage>

                <span />

                <Row vertical="middle" horizontal="center">
                    <Button onClick={onBack} size="large">
                        {trans('ButtonLabel')}
                    </Button>
                </Row>
            </Stack>
        </DialogModal>
    );
};

export default CustomerBookingConditionDialog;
